export default "__VITE_ASSET__CyHEeJEG__"